// const supportingInfoElements = [
//   {
//     id: 1,
//     name: "Attachment",
//     object: {
//       category: "attachment",
//       attachment: "",
//       fileName: "",
//       fileType: "",
//     },
//   },
//   {
//     id: 2,
//     name: "Birth Weight",
//     object: {
//       category: "birth-weight",
//       value: null,
//       valueUnit: "kg",
//     },
//   },
//   {
//     id: 3,
//     name: "Chief Complaint",
//     object: {
//       category: "chief-complaint",
//       codeText: "",
//       code: "",
//       valueUnit: "",
//       value: null,
//     },
//   },
//   {
//     id: 4,
//     name: "Days Supply",
//     object: {
//       category: "days-supply",
//       valueUnit: "d",
//       value: null,
//     },
//   },
//   {
//     id: 5,
//     name: "Employment Impacted",
//     object: {
//       category: "employment-impacted",
//       startDate: null,
//       endDate: null,
//     },
//   },
//   {
//     id: 6,
//     name: "Hospitalized",
//     object: {
//       category: "hospitalized",
//       startDate: null,
//       endDate: null,
//     },
//   },
//   {
//     id: 7,
//     name: "ICU Hours",
//     object: {
//       category: "icu-hours",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "h",
//     },
//   },
//   {
//     id: 8,
//     name: "Info",
//     object: {
//       category: "info",
//       value: null,
//       valueUnit: "",
//     },
//   },
//   {
//     id: 9,
//     name: "Lab Test",
//     object: {
//       category: "lab-test",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "",
//       codeText: "",
//       code: "",
//     },
//   },
//   {
//     id: 10,
//     name: "Last Menstrual Period",
//     object: {
//       category: "last-menstrual-period",
//       startDate: null,
//     },
//   },
//   {
//     id: 11,
//     name: "Missing Tooth",
//     object: {
//       category: "missingtooth",
//       startDate: null,
//       codeText: "",
//       code: "",
//       reason: null,
//     },
//   },
//   {
//     id: 12,
//     name: "Onset",
//     object: {
//       category: "onset",
//       startDate: null,
//       codeText: "",
//       code: "",
//     },
//   },
//   {
//     id: 13,
//     name: "Oxygen Saturation",
//     object: {
//       category: "oxygen-saturation",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "%",
//     },
//   },
//   {
//     id: 14,
//     name: "Pulse",
//     object: {
//       category: "pulse",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "/min",
//     },
//   },
//   {
//     id: 15,
//     name: "Reason For Visit",
//     object: {
//       category: "reason-for-visit",
//       codeText: "",
//       code: "",
//     },
//   },
//   {
//     id: 16,
//     name: "Respiratory Rate",
//     object: {
//       category: "respiratory-rate",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "/min",
//     },
//   },
//   {
//     id: 17,
//     name: "Temperature",
//     object: {
//       category: "temperature",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "Cel",
//     },
//   },
//   {
//     id: 18,
//     name: "Ventilation Hours",
//     object: {
//       category: "ventilation-hours",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "h",
//     },
//   },
//   {
//     id: 19,
//     name: "Vital Sign Diastolic",
//     object: {
//       category: "vital-sign-diastolic",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "mm[Hg]",
//     },
//   },
//   {
//     id: 20,
//     name: "Vital Sign Height",
//     object: {
//       category: "vital-sign-height",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "cm",
//     },
//   },
//   {
//     id: 21,
//     name: "Vital Sign Systolic",
//     object: {
//       category: "vital-sign-systolic",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "mm[Hg]",
//     },
//   },
//   {
//     id: 22,
//     name: "Vital Sign Weight",
//     object: {
//       category: "vital-sign-weight",
//       startDate: null,
//       endDate: null,
//       value: null,
//       valueUnit: "kg",
//     },
//   },
// ];

// export default supportingInfoElements;

import AttachFileIcon from '@mui/icons-material/AttachFile'
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly'
import WarningIcon from '@mui/icons-material/Warning'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import WorkOffIcon from '@mui/icons-material/WorkOff'
import LocalHospitalIcon from '@mui/icons-material/LocalHospital'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import InfoIcon from '@mui/icons-material/Info'
import ScienceIcon from '@mui/icons-material/Science'
import EventNoteIcon from '@mui/icons-material/EventNote'
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import FavoriteIcon from '@mui/icons-material/Favorite'
import AirIcon from '@mui/icons-material/Air'
import ThermostatIcon from '@mui/icons-material/Thermostat'
import HeightIcon from '@mui/icons-material/Height'
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward' // For vital-sign-systolic
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward' // For vital-sign-diastolic
import EventIcon from '@mui/icons-material/Event' // For last-menstrual-period

const supportingInfoElements = [
  {
    id: 1,
    name: 'Attachment',
    icon: <AttachFileIcon />,
    object: {
      category: 'attachment',
      attachment: '',
      fileName: '',
      fileType: ''
    }
  },
  {
    id: 2,
    name: 'Birth Weight',
    icon: <ChildFriendlyIcon />,
    object: {
      category: 'birth-weight',
      value: null,
      valueUnit: 'kg'
    }
  },
  {
    id: 3,
    name: 'Chief Complaint',
    icon: <WarningIcon />,
    object: {
      category: 'chief-complaint',
      codeText: '',
      code: '',
      valueUnit: '',
      value: null
    }
  },
  {
    id: 4,
    name: 'Days Supply',
    icon: <CalendarTodayIcon />,
    object: {
      category: 'days-supply',
      valueUnit: 'd',
      value: null
    }
  },
  {
    id: 5,
    name: 'Employment Impacted',
    icon: <WorkOffIcon />,
    object: {
      category: 'employment-impacted',
      startDate: null,
      endDate: null
    }
  },
  // {
  //   id: 6,
  //   name: "Hospitalized",
  //   icon: <LocalHospitalIcon />,
  //   object: {
  //     category: "hospitalized",
  //     startDate: null,
  //     endDate: null,
  //   },
  // },
  {
    id: 7,
    name: 'ICU Hours',
    icon: <AccessTimeIcon />,
    object: {
      category: 'icu-hours',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: 'h'
    }
  },
  {
    id: 8,
    name: 'Info',
    icon: <InfoIcon />,
    object: {
      category: 'info',
      value: null,
      valueUnit: ''
    }
  },
  {
    id: 9,
    name: 'Lab Test',
    icon: <ScienceIcon />,
    object: {
      category: 'lab-test',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: '',
      codeText: '',
      code: ''
    }
  },
  {
    id: 10,
    name: 'Last Menstrual Period',
    icon: <EventIcon />,
    object: {
      category: 'last-menstrual-period',
      startDate: null
    }
  },
  {
    id: 11,
    name: 'Missing Tooth',
    icon: <SentimentVeryDissatisfiedIcon />,
    object: {
      category: 'missingtooth',
      startDate: null,
      codeText: '',
      code: '',
      reason: null
    }
  },
  {
    id: 12,
    name: 'Onset',
    icon: <PlayArrowIcon />,
    object: {
      category: 'onset',
      startDate: null,
      codeText: '',
      code: ''
    }
  },
  {
    id: 13,
    name: 'Oxygen Saturation',
    icon: <FavoriteIcon />,
    object: {
      category: 'oxygen-saturation',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: '%',
      reason: '888'
    }
  },
  {
    id: 14,
    name: 'Pulse',
    icon: <FavoriteBorderIcon />,
    object: {
      category: 'pulse',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: '/min',
      reason: '998'
    }
  },
  {
    id: 15,
    name: 'Reason For Visit',
    icon: <EventNoteIcon />,
    object: {
      category: 'reason-for-visit',
      codeText: '',
      code: ''
    }
  },
  {
    id: 16,
    name: 'Respiratory Rate',
    icon: <AirIcon />,
    object: {
      category: 'respiratory-rate',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: '/min',
      reason: '88'
    }
  },
  {
    id: 17,
    name: 'Temperature',
    icon: <ThermostatIcon />,
    object: {
      category: 'temperature',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: 'Cel',
      reason: '88'
    }
  },
  {
    id: 18,
    name: 'Ventilation Hours',
    icon: <AirIcon />,
    object: {
      category: 'ventilation-hours',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: 'h'
    }
  },
  {
    id: 19,
    name: 'Vital Sign Diastolic',
    icon: <ArrowDownwardIcon />,
    object: {
      category: 'vital-sign-diastolic',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: 'mm[Hg]',
      reason: '888'
    }
  },
  {
    id: 20,
    name: 'Vital Sign Height',
    icon: <HeightIcon />,
    object: {
      category: 'vital-sign-height',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: 'cm',
      reason: '999.9'
    }
  },
  {
    id: 21,
    name: 'Vital Sign Systolic',
    icon: <ArrowUpwardIcon />,
    object: {
      category: 'vital-sign-systolic',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: 'mm[Hg]',
      reason: '888'
    }
  },
  {
    id: 22,
    name: 'Vital Sign Weight',
    icon: <MonitorWeightIcon />,
    object: {
      category: 'vital-sign-weight',
      startDate: null,
      endDate: null,
      value: null,
      valueUnit: 'kg',
      reason: '999.9'
    }
  },

  {
    id: 23,
    name: 'History of Present Illness',
    icon: <InfoIcon />,
    object: {
      category: 'history-of-present-illness',
      value: null,
      valueUnit: ''
    }
  },
  {
    id: 24,
    name: 'Past Medical & Surgical Historys',
    icon: <InfoIcon />,
    object: {
      category: 'patient-history',
      value: null,
      valueUnit: ''
    }
  },
  {
    id: 25,
    name: 'Physical Examination',
    icon: <InfoIcon />,
    object: {
      category: 'physical-examination',
      value: null,
      valueUnit: ''
    }
  },
  {
    id: 26,
    name: 'Treatment Plan',
    icon: <InfoIcon />,
    object: {
      category: 'treatment-plan',
      value: null,
      valueUnit: ''
    }
  },
  {
    id: 27,
    name: 'Estimated Length of Stay',
    icon: <InfoIcon />,
    object: {
      category: 'estimated-Length-of-Stay',
      value: null,
      valueUnit: 'd'
    }
  },
  {
    id: 28,
    name: 'Morphology',
    icon: <WarningIcon />,
    object: {
      category: 'morphology',
      codeText: '',
      code: ''
    }
  },
  {
    id: 29,
    name: 'Investigation Result',
    icon: <SentimentVeryDissatisfiedIcon />,
    object: {
      category: 'investigation-result',
      codeText: '',
      code: '',
      attachment: '',
      fileName: '',
      fileType: ''
    }
  },
  {
    id: 30,
    name: 'Admission Weight',
    icon: <ChildFriendlyIcon />,
    object: {
      category: 'admission-weight',
      value: null,
      valueUnit: 'kg'
    }
  }
]

export default supportingInfoElements
